import Vue from "vue";
import router from "@/router";
import store from "@/store";
import App from "@/components/App";
import VueMoment from "vue-moment";
import VeeValidateLaravel from "@/plugins/vee-validate-laravel";

import "@/plugins";
import "@/components";

Vue.use(VeeValidateLaravel);
Vue.use(VueMoment);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  ...App
});



// WEBPACK FOOTER //
// ./resources/assets/js/app.js